import * as Yup from 'yup';
import { TripAlterations } from './TripAlterations';
import { FinalExpenses } from './FinalExpenses';
import { TripExpense } from './TripExpense';

const validFinalExpenses: Yup.ObjectSchema<FinalExpenses> = Yup.object().shape({
  alterations: Yup.object<TripAlterations>().shape({
    id: Yup.number().required(),
    startDate: Yup.string().required('Required'),
    endDate: Yup.string().required('Required'),
    extraTravelDays: Yup.number().required('Required'),
  }),
  itemizedExpenses: Yup.array()
    .required()
    .of(
      Yup.object().shape({
        id: Yup.number().nullable(),
        // title needs to match the type of Expense title
        title: Yup.mixed<TripExpense['title']>()
          .oneOf(
            ['Hotel', 'Air Travel', 'Ground Travel', 'Other'],
            'Invalid title'
          )
          .required('Title is required'),
        cost: Yup.number().required('Required'),
        description: Yup.string().required('Required'),
        isQuoted: Yup.boolean().required(),
        receipt: Yup.mixed<File | string>().required('Receipt is required'),
      })
    ),
});

export default validFinalExpenses;
